import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IBatchesSupervisionFormMeta {
  id: FormInputMeta;
  label: FormInputMeta;
  seq: FormInputMeta;
  processingDate: FormInputMeta;
  startDate: FormInputMeta;
  endDate: FormInputMeta;
  status: FormInputMeta;

  schema: any;
}

const batchesSupervisionFormMeta = {} as IBatchesSupervisionFormMeta;

batchesSupervisionFormMeta.id = {
  name: "id",
  type: "text",
  label: "Id",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire"),
};

batchesSupervisionFormMeta.label = {
    name: "label",
    type: "text",
    label: "Libellé",
    placeholder: "Veuillez entrer le Libellé svp...",
    validation: yup.string().required("Champ obligatoire !")
};
  
batchesSupervisionFormMeta.processingDate = {
    name: "processingDate",
    type: "date",
    label: "Date Traitement",
    placeholder: "Veuillez entrer la date de traitement svp...",
    validation: yup.date().required("Champ obligatoire !")
};
  
batchesSupervisionFormMeta.startDate = {
    name: "startDate",
    type: "date",
    label: "Date Début",
    placeholder: "Veuillez entrer la date de début svp...",
    validation: yup.date().required("Champ obligatoire !")
};
  
batchesSupervisionFormMeta.endDate = {
    name: "endDate",
    type: "date",
    label: "Date Fin",
    placeholder: "Veuillez entrer la date de fin svp...",
    validation: yup.date().required("Champ obligatoire !")
};
  
batchesSupervisionFormMeta.status = {
    name: "status",
    type: "text",
    label: "Statut",
    placeholder: "Veuillez entrer le statut svp...",
    validation: yup.string().required("Champ obligatoire !")
};
  

batchesSupervisionFormMeta.schema = yup.object().shape(getValidationSchema(batchesSupervisionFormMeta));

export default batchesSupervisionFormMeta;